
  const initialState = { }
  
  export default function IntakeReducer(state = initialState, action) {
    switch (action.type) {
      case 'INIT_INTAKE_SHIPMENTS': {
        return Object.assign({}, state, { ...action.payload })
      }
      default:
        return state
    }
  }
  